export function isCompetitionRuntimeEnabled(env = process.env) {
  const value = env.VUE_APP_COMPETITION_RUNTIME_ENABLED
  if (value === undefined || value === null || value === '') return true
  return !['false', '0', 'no', 'off'].includes(String(value).trim().toLowerCase())
}
